import * as React from "react";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import {
  IBktValidatedTextFieldProps,
  BktValidatedTextField,
  BktTextFieldProps
} from "front-end-lib/core";

interface IMddValidatedTextFieldProps extends IBktValidatedTextFieldProps {
  id: string;
  labelProps?: {
    labelText?: string | React.ReactNode;
    className?: string;
    showInfoIcon?: boolean;
    infoIconTooltip?: string;
    infoIconId?: string;
    infoIconTestId?: string;
  };
}

export const MddValidatedTextField = (props: IMddValidatedTextFieldProps) => {
  const { id, labelProps, textFieldProps, ...other } = props;

  const defaultTextProps = {
    id: `${id}_value`,
    type: "text",
    variant: "outlined",
    placeholder: ""
  };

  // include our default props but allow the caller to override if desired
  const mergedTextFieldProps = {
    ...textFieldProps,
    textProps:
      textFieldProps && textFieldProps.textProps
        ? {
            ...defaultTextProps,
            ...textFieldProps.textProps
          }
        : { ...defaultTextProps }
  } as BktTextFieldProps;

  const renderLabelWithInfoIcon = React.useCallback(() => {
    if (!labelProps || !labelProps.labelText) return null;

    const labelContent = labelProps.showInfoIcon ? (
      <span>
        {labelProps.labelText}
        <span
          className="mdd-validated-text-field--info-icon"
          title={labelProps.infoIconTooltip || ""}
        >
          <InfoIcon
            fontSize="small"
            id={labelProps.infoIconId || `${id}InfoIcon`}
            data-testid={labelProps.infoIconTestId || `${id}InfoIcon`}
          />
        </span>
      </span>
    ) : (
      labelProps.labelText
    );

    return (
      <div
        className={labelProps.className || ""}
        id={`${id}_label`}
        data-testid={`${id}_label`}
      >
        {labelContent}
      </div>
    );
  }, [id, labelProps]);

  return (
    <div className="mdd-validated-text-field-div--container" key={`${id}_key`}>
      {renderLabelWithInfoIcon()}
      <BktValidatedTextField
        key={`${id}_txtField`}
        {...other}
        textFieldProps={{ ...mergedTextFieldProps }}
      />
    </div>
  );
};
